import React, {useEffect,useState,useContext,useMemo,useCallback,useRef} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DataTable from "react-data-table-component";
import RefreshContext from './RefreshContext';
import ReactQuill from "react-quill-new";

import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,Checkbox} from '@mui/material'; 
import {Edit as EditIcon,Visibility as VisibilityIcon ,DownloadOutlined,ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted } from '@mui/icons-material';

import $ from 'jquery';

function ReRgister(){

const { refreshKey } = useContext(RefreshContext);
   const [jobDescription,setJobDescription]= useState("");
   const [sendType, setSendType] = useState("dst"); // 'ivr' | 'dst'
     
const { aid ,aidtype} = useParams();
const [recruiterCandidates, setStaff2] = useState([]); // recruiter

const [fileUrl, setFileUrl] = useState(null);
const [fileType, setFileType] = useState(null);
const [total,setTotal]= useState(0);
const [results, setResults] = useState(null);
const [showResultsModal, setShowResultsModal] = useState(false);

const [loadings, setTableLoading] = useState(true);
const [newloading,setNewLoading] = useState(false);

const [selectedRows, setSelectedRows] = useState([]);
const [activeTab, setActiveTab] = useState("recruiter");
const [showRecruiter, setShowRecruiter] = useState(false);
const [showVendor, setShowVendor] = useState(false);
const [selectedRecruiter, selectRecruiter] = useState(null);
const [currentRows, setFilteredStaff] = useState([]);
const [ivrdata,setIvrData] = useState("");
const [NewFORM,setNewFORM] = useState("");
const [ivr,setIvr] = useState("");
const [candidates,setCandidates]= useState([]);
const [candidatesId,setCandidatesId]= useState([]);

const [pending, setPending] = useState([]);
const [inter, setSuccess] = useState([]);
const [other, setReject] = useState([]);
const [notinter, setDecline] = useState([]);
const [ivrinter,setIvrinter]=useState([]);
const [campid,setCampid]=useState('');
const [allCandidates, setStaff] = useState([]); // vendor
const [selectedStatus, setSelectedStatus] = useState('all'); // 'all', 'inter', 'notinter', 'other', 'pending'
const [extraCandidateData, setExtraCandidateData] = useState({});
const [hasIVr,setHasIVr]= useState(0);
const [currentPage, setCurrentPage] = useState(1);
const [totalRows, setTotalRows] = useState(0); // Set this from your API response
const limit = 50; 
const maxPage = Math.ceil(totalRows / limit);
const [order, setOrder] = useState('asc'); 
const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
const [globalFilterText, setGlobalFilterText] = useState('');
const [columnFilters, setColumnFilters] = useState({});
const [fileInfo, setFileInfo] = useState(null);
const [team, setTEam] = useState([]);
const [dstteam,setSelectTeam] = useState([]);
const [selectvoice,setVoice] = useState('4');
const [selectLang,setLanguage] = useState('2');

const voiceDefaultMap = { '2': '4', '1': '2' };

const [filterText, setFilterText] = useState(''); // Current input value
const [debouncedFilter, setDebouncedFilter] = useState(''); // Value after 700ms

 // Add these to your component
const popoverRef = useRef(null);
const [isMenuOpen, setIsMenuOpen] = useState(false);
const [activeRemark, setActiveRemark] = useState('');
const [currentStep, setCurrentStep] = useState(1);
const navigate = useNavigate();

   const voice = [
    { value: '1', label: 'KAJAL' },
    { value: '3', label: 'RAJ' },
    { value: '5', label: 'ANKITA' },
    { value: '4', label: 'YASH' },
    { value: '2', label: 'PRIYA' }
  ];

  const lanugage = [
    { value: '2', label: 'HINDI' },
    { value: '1', label: 'ENGLISH' }
  ];

useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedFilter(filterText);
  }, 700);

  return () => clearTimeout(handler); // Cleanup on every keystroke
}, [filterText]);

function debounce(func, wait) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
}

const debouncedSave = useCallback(
        debounce((candidateId, field, value) => {
           if(value!=''){ 
            const formData = new FormData();
            formData.append("aid", aid);
            formData.append("aidtype", aidtype);
            formData.append("candidateid", candidateId);
            formData.append("field_name", field);
            formData.append("field_value", value);

            // Fetch call to your PHP/Backend
            axios.post(apiurl+"dst_candidate.php",formData);
          }
        }, 800), 
        [aid, aidtype] // Re-run if these change
    );
    // Function to handle changes in any custom input field
    const handleInputChange = (candidateId, fieldName, value) => {
        setExtraCandidateData(prevData => ({
            ...prevData,
            [candidateId]: {
                ...(prevData[candidateId] || {}),
                [fieldName]: value,
            },
        }));
         debouncedSave(candidateId, fieldName, value);
    };

const handleOpenPopover = (event, remark) => {
    // Set the remark data
    setActiveRemark(remark);
    // Use the clicked element as the reference for the ref
    popoverRef.current = event.currentTarget; 
    setIsMenuOpen(true);
};

const handleClosePopover = () => {
    setIsMenuOpen(false);
    setActiveRemark('');
};

 const handleFileChange2 = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileInfo({
      name: file.name,
      size: (file.size / 1024).toFixed(2) // KB
    });
  };

const [metaData, setMetaData] = useState({
  appname: '',
  edit: 0,
  del: false,
  add: 0,
  view: false,
  typess:'',
  icon:'',
  checkbox:0,
  defaultShow:10,
  notes: ''
});
const [stats,setStats]= useState([]);
const [requirement, setRequirement] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [isSubmitting, setIsSubmitting] = useState(false);
const fetchData = async (page) => {
  const response = await axios.get(apiurl+'dst_candidate.php?subdomain=react&aid='+aid+"&aidtype="+aidtype+"&page="+page); // Replace with your API endpoint
  if(response.data.status==false){
                                Swal.fire({
                                        position: "top-center",
                                        icon: "error",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    });
        return false;
   }
   setCurrentStep(1);

   //setCampid(response.data.camp);
   setStats(response.data.stats);
   if(response.data.add===1){
   setNewFORM(response.data.main[0]);
   setLanguage(response.data.main[0].lang);
   setJobDescription(response.data.main[0].descr);
   setVoice(response.data.main[0].voice);
   setTEam(response.data.team || []);
   setSelectTeam((response.data.assignedDstTeam || []).map(String));
   }
  
   setStaff(response.data.all || []);
   
   setPending(response.data.pending || []);
   setIvrinter(response.data.inter_ivr || []);
   setSuccess(response.data.inter || []);
   setReject(response.data.other || []);
   setDecline(response.data.notinter || []);
   setHasIVr(response.data.hasIVr);
   setMetaData({
     add:response.data.add,
     edit:response.data.edit,
     notes:response.data.notes
   });
   setTableLoading(false);
   
};

const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

useEffect(() => {
  document.title = aidtype==='10' ? "Self line up Candidate | MERAQUI" : (aidtype==='301' || aidtype=='302' ? (aidtype==='301'? 'Open Campaign Line up' : 'Paid Campaign Line up') : (aidtype==='202' ? 'CAMPAIGN CANDIDATE': 'Candidates | MERAQUI'));
    fetchData(currentPage);
  $('#modalclose').on('click', function () {
    $("#hidden").val("");
    $("#reset").click();
    setFileType(null);
    setFileUrl(null);
    checks('1');
  });

}, [refreshKey,aid,aidtype,currentPage]);

useEffect(() => {
  let newFilteredStaff = [];

  switch (selectedStatus) {
    case 'pending':
      newFilteredStaff = pending;
      break;
    case 'inter':
      newFilteredStaff = inter;
      break;
   case 'inter_ivr':
      newFilteredStaff = ivrinter;
      break;
    case 'nointer':
      newFilteredStaff = notinter;
      break;
    case 'other':
      newFilteredStaff = other;
      break;
    case 'all':
    default:
      newFilteredStaff = allCandidates;
      break;
  }

  setFilteredStaff(newFilteredStaff);
}, [selectedStatus, allCandidates, pending, inter, notinter, other,ivrinter]);

const totalSteps = 2;
const validateStep = (stepNumber) => {
    let valid = true;
    const requiredFields = document.querySelectorAll(
        `.form-step[data-step="${stepNumber}"] [required]`
    );

    requiredFields.forEach((input) => {
        if (!input.value.trim()) {
            valid = false;
            let errorSpan = input.nextElementSibling;
            if (errorSpan && errorSpan.classList.contains("error-text")) {
                errorSpan.remove();
            }
            const span = document.createElement("span");
            span.textContent = "Empty";
            span.style.color = "red";
            span.style.paddingLeft = '4px';
            input.insertAdjacentElement("afterend", span);
        }
    });

    if (stepNumber === 1) {
        if (!selectedStatus) {
            valid = false;
            const label = document.querySelector('label[htmlFor="status"]');
            if (label) {
                label.style.color = 'red';
            }
        }
    }
    return valid;
};

const handleNext = async () => {
     if (isSubmitting) return;
     try {
          setIsSubmitting(true);
          const formData = new FormData($("#bulkForm")[0]);
          formData.append("hidden",aid);
          formData.append("aidtype",aidtype);
          if(!$("#bulk")[0].files.length){
              Swal.fire({
               position:'top-center',
               icon:'question',
               title:"Please select the bulk candidate file"
            });
            return false;
          }
              
          $("#showLoader").removeClass("d-none").addClass("d-flex");
          const res = await axios.post(apiurl + "dst_candidate.php", formData);
          
          if (res.data.status) {
            Swal.fire({
              icon: res.data.status ? 'success' : 'error',
              title: res.data.messages,
              timer: 1500,
              showConfirmButton: false,
            }).then(()=>{
                if(currentStep===1){
                    setCurrentStep(prev => prev + 1);
                }
            });
           
          } else {
            Swal.fire("Error", res.data.messages || "Step 1 save failed", "error");
          }
    
      } catch (err) {
        console.error("Error:", err);
        Swal.fire("Error", "Server connection failed!", "error");
      } finally {
        $("#showLoader").removeClass("d-flex").addClass("d-none");
        setIsSubmitting(false);
      }
};

const candidatecolumns = [
  {
        name: "Name",
        width:"160px",
        sortable: true,
        cell: (row) => (
            <Box display="flex" alignItems="center">
                <IconButton 
                    size="small" 
                    color="primary"
                    onClick={(e) => handleOpenPopover(e, extraCandidateData[row.candidateid]?.remark)}
                >
                    <FormatListBulleted fontSize="small" />
                </IconButton>
                <Typography variant="body2">{row.name}</Typography>
            </Box>
        ),
    },
    { name: "Mobile", selector: (row) => row.mobile, sortable: true,width:"130px" },
];
const responseOptions = [
    // Primary Statuses
    { label: 'Not interested', value: 'decline' },
    { label: 'Working', value: 'WORKING' },
    { label: 'Interested', value: 'success' },
    { label: 'ID sent', value: 'ID_SENT' },
    
    // Call/Availability Issues
    { label: 'RNR', value: 'RNR' }, // Ring No Response
    { label: 'Busy', value: 'BUSY' },
    { label: 'Attend later', value: 'ATTEND_LATER' },
    { label: 'Call Later', value: 'CALL_LATER' },
    
    // Rejection Reasons / Issues
    { label: 'Salary Issue', value: 'SALARY_ISSUE' },
    { label: 'Location Issue', value: 'LOCATION_ISSUE' },
    { label: 'Job Mismatch', value: 'JOB_MISMATCH' },
    { label: 'Transport Issue', value: 'TRANSPORT_ISSUE' },
    { label: 'Food Issue', value: 'FOOD_ISSUE' },
    { label: 'Late Working hour', value: 'LATE_WORKING_HOUR' },
    { label: 'OT Not Available', value: 'OT_NOT_AVAILABLE' },
    { label: 'Security Deposit required', value: 'SECURITY_DEPOSIT' },
    
    // Technical/Other
    { label: 'Switch Off', value: 'SWITCH_OFF' },
    { label: 'Network Issue', value: 'NETWORK_ISSUE' },
    {label: 'Other', value : 'reject'},
    {label:'Pending', value:'pending'},
];

const transformCandidatesToExtraData = (candidatesArray) => {
  
    return candidatesArray.reduce((acc, candidate) => {
        const idKey = candidate.candidateid; // <-- USE THE CORRECT ID KEY
        
        if (idKey) {
            acc[idKey] = {
                age: candidate.age || '',
                location: candidate.location || '',
                experience: candidate.experience || '',
                qualification: candidate.qualification || '',
                responseCategory: candidate.response || '', // or candidate.response_category etc.
                dstRemark: candidate.dremark || '',
                email :candidate.email || '',
                profile : candidate.profile || '',
                remark: candidate.remark || ''
            };
        }
        return acc;
    }, {});
};

const extraColumns = [
    {
        name: 'Profile',
        width: '170px',
        cell: row => (
            <input
                type="text"
                value={extraCandidateData[row.candidateid]?.profile || ''}
                onChange={e => handleInputChange(row.candidateid, 'profile', e.target.value)}
                className="form-control form-control-sm" // Use small Bootstrap/custom class
               placeholder='Enter Profile'
            />
        ),
        sortable: false,
        grow: 0.5,
    },
    {
        name: 'Email',
        width: '250px',
        cell: row => (
            <input
                type="email"
                value={extraCandidateData[row.candidateid]?.email || ''}
                onChange={e => handleInputChange(row.candidateid, 'email', e.target.value)}
                className="form-control form-control-sm" // Use small Bootstrap/custom class
                placeholder='Enter Email'
            />
        ),
        sortable: false,
        grow: 0.5,
    },
    {
        name: 'Age',
        width: '120px',
        cell: row => (
            <input
                type="number"
                value={extraCandidateData[row.candidateid]?.age || ''}
                onChange={e => handleInputChange(row.candidateid, 'age', e.target.value)}
                className="form-control form-control-sm" // Use small Bootstrap/custom class
                style={{ width: '80px' }}
                min="16" placeholder='Age'
            />
        ),
        sortable: false,
        grow: 0.5,
    },
    // 2. Candidate Location (Text Input)
    {
        name: 'Location',
        width: '170px',
        cell: row => (
            <input
                type="text"
                value={extraCandidateData[row.candidateid]?.location || ''}
                onChange={e => handleInputChange(row.candidateid, 'location', e.target.value)}
                className="form-control form-control-sm" placeholder='Location'
            />
        ),
        sortable: false,
    },
    // 3. Experience (Select Dropdown)
    {
        name: 'Experience',
        width: '170px',
        cell: row => (
            <input
                type="text"
                value={extraCandidateData[row.candidateid]?.experience || ''}
                onChange={e => handleInputChange(row.candidateid, 'experience', e.target.value)}
                className="form-control form-control-sm" placeholder='Experience'
            />
        ),
        sortable: false,
    },
    // 4. Qualification (Select Dropdown)
    {
        name: 'Qualification',
        width: '170px',
        cell: row => (
            <input
                type="text"
                value={extraCandidateData[row.candidateid]?.qualification || ''}
                onChange={e => handleInputChange(row.candidateid, 'qualification', e.target.value)}
                className="form-control form-control-sm" placeholder='Qualification'
            />
        ),
        sortable: false,
    },
    {
    name: 'Response Category',
    width: '180px',
    cell: row => {
        // Get the current value from your state
        const currentValue = extraCandidateData[row.candidateid]?.responseCategory || '';

        return (
            <select
                value={currentValue}
                onChange={(e) => handleInputChange(row.candidateid, 'responseCategory', e.target.value)}
                className="form-select form-select-sm" // Bootstrap classes for styling
                style={{ 
                    fontSize: '13px', 
                    height: '32px', 
                    padding: '0 8px',
                    minWidth: '150px' 
                }}
            >
                <option value="">Select Status...</option>
                {responseOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        );
    },
    sortable: false,
    grow: 1.5,
  },
    // 6. DST Remark (Text Input)
    {
        name: 'DST Remark',
        width: '360px',
        cell: row => (
            <input
                type="text"
                value={extraCandidateData[row.candidateid]?.dstRemark || ''}
                onChange={e => handleInputChange(row.candidateid, 'dstRemark', e.target.value)}
                className="form-control form-control-sm" placeholder='DST remark'
            />
        ),
        sortable: false,
    },
];

const allColumns = useMemo(() => [...candidatecolumns, ...extraColumns], [candidatecolumns, extraCandidateData]);

const getButtonClass = (filter) => {
  const baseClass = 'btn text-white position-relative';
  return selectedStatus === filter ? `${baseClass} btn-primary` : `${baseClass} btn-info text-dark`;
};

const handleSelectAll = (checked) => {
    if (checked) {
        // Select all rows currently visible/processed
        const allIds = processedData.map(row => row.id);
        setSelectedRows(allIds);
    } else {
        // Deselect all
        setSelectedRows([]);
    }
};

  const handleRowSelect = (id, checked) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
    }
  };


const stableSort = (array, comparator) => {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
              return order;
          }
          return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
  };
  
    const getComparator = (order, orderBy) => {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };
    
    const descendingComparator = (a, b, orderBy) => {
        const valA = orderBy(a);
        const valB = orderBy(b);
    
        if (valB < valA) {
            return -1;
        }
        if (valB > valA) {
            return 1;
        }
        return 0;
    };
    
 const ColumnHeaderWithFilter = ({
    column,
    orderBySelector,
    order,
    handleRequestSort,
    columnFilters,
    setColumnFilters,
}) => {

    const accessorKey = column.accessorKey;
    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;
    const isSorted = orderBySelector === column.selector;

    const [anchorEl, setAnchorEl] = useState(null);
    const [localOpenKey, setLocalOpenKey] = useState(null);

    // ✅ Temporary input state (important)
    const [tempFilterValue, setTempFilterValue] = useState(
        columnFilters[accessorKey] || ''
    );

    const isMenuOpen = localOpenKey === accessorKey;
    const currentFilter = columnFilters[accessorKey] || '';

    // Sync temp value when filter changes externally
    useEffect(() => {
        setTempFilterValue(currentFilter);
    }, [currentFilter]);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    // ✅ Apply filter only when Search clicked
    const applyFilter = () => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: tempFilterValue
        }));
        handleClose();
    };

    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {

        if (column.filterType === 'select') {
            const filterOptions = column.dynamicFilterOptions || [];

            return (
                <MuiSelect
                    value={tempFilterValue}
                    onChange={(e) => setTempFilterValue(e.target.value)}
                    size="small"
                    fullWidth
                >
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    type="date"
                    size="small"
                    value={tempFilterValue}
                    onChange={(e) => setTempFilterValue(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />
            );
        }

        // Default: text filter
        return (
            <TextField
                label={`Filter ${column.header}`}
                variant="outlined"
                size="small"
                value={tempFilterValue}
                onChange={(e) => setTempFilterValue(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        applyFilter();
                    }
                }}
                autoFocus
                fullWidth
            />
        );
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                '& .MuiTableSortLabel-root': { flexGrow: 1 }
            }}
        >
            {/* Sorting */}
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={
                    isSorted
                        ? (order === 'desc' ? ArrowDropDown : ArrowDropUp)
                        : undefined
                }
                sx={{
                    cursor: isSortable ? 'pointer' : 'default',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {/* Filter Button */}
            {isFilterable && (
                <>
                    <IconButton
                        size="small"
                        onClick={handleClick}
                        sx={{
                            ml: 1,
                            p: 0,
                            color: currentFilter
                                ? 'primary.main'
                                : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()}
                        PaperProps={{
                            sx: { width: 250, p: 2, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                    >
                        <Box sx={{ width: '100%' }}>
                            {renderFilterInput()}
                        </Box>

                        {/* Search Button */}
                        <Button
                            variant="contained"
                            size="small"
                            sx={{ mt: 2, textTransform: 'none', width: '100%' }}
                            onClick={applyFilter}
                        >
                            Search
                        </Button>

                        {/* Clear Button */}
                        {currentFilter && (
                            <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({
                                        ...prev,
                                        [accessorKey]: ''
                                    }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none', width: '100%' }}
                            >
                                Clear Filter
                            </Button>
                        )}
                    </Menu>
                </>
            )}
        </Box>
    );
};
  
 const EditData = async (edit, sss) => {
          
          $("#showLoader").removeClass('d-none').addClass('d-flex');
          const response = await axios.get(apiurl + 'view_candidate.php?edit=' + edit+"&sss="+sss);
          if (response.data.status == true) {
              setRequirement(response.data.data[0]);
              $("#tera_modal33").click();
          }
          $("#showLoader").removeClass('d-flex').addClass('d-none');
  };

 const dynamicFilterOptions = useMemo(() => {
            const options = {};
            const selectAccessors = ['profile','type','ress'];
            
            selectAccessors.forEach(key => {
                const uniqueValues = new Set();
                currentRows.forEach(row => {
                    if (row[key]) {
                        uniqueValues.add(row[key]);
                    }
                });
                options[key] = Array.from(uniqueValues).sort();
            });
            return options;
        }, [currentRows]);
  
  const BASE_COLUMNS_DEFINITION = [
    { accessorKey: 'date', selector: (row) => row.date, filterType: 'date' },
              { accessorKey: 'name', selector: (row) => row.name, filterType: 'text' },
              { accessorKey: 'mobile',  selector: (row) => row.mobile, filterType: 'text' },
              { accessorKey: 'profile', selector: (row) => row.profile, filterType: 'select', dynamicFilterOptions:dynamicFilterOptions['profile'] },
               { 
                  accessorKey: 'email', 
                  selector: (row) => row.email, 
                  filterType: 'text',
              },
];
  
 const processedData = useMemo(() => {
          let filtered = currentRows;
          const lowerCaseFilter = globalFilterText.toLowerCase();
  
          // 1. Apply Global Filter
          if (lowerCaseFilter) {
              filtered = filtered.filter(row => 
                  BASE_COLUMNS_DEFINITION.some(column => {
                      const value = column.selector ? String(column.selector(row)) : '';
                      return value.toLowerCase().includes(lowerCaseFilter);
                  })
              );
          }
  
          // 2. Apply Column Filters
          filtered = filtered.filter(row => {
              return BASE_COLUMNS_DEFINITION.every(column => {
                  const accessorKey = column.accessorKey;
                  const filterValue = columnFilters[accessorKey];
  
                  if (!filterValue) return true;
                  if (!column.selector) return true;
  
                  const rowValue = String(column.selector(row));
  
                  switch (column.filterType) {
                      case 'select':
                          // Must match the selected value exactly
                          return rowValue === filterValue; 
                          
                      case 'date':
                          // Check if the date string (e.g., '2024-01-15') includes the filter date
                          return rowValue.includes(filterValue); 
                          
                      case 'text':
                      default:
                          return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                  }
              });
          });
  
          // 3. Sorting Logic
          const sortColumn = BASE_COLUMNS_DEFINITION.find(col => col.selector === orderBySelector);
  
          if (sortColumn) {
              return stableSort(filtered, getComparator(order, sortColumn.selector));
          }
          
          return filtered;
  
 }, [currentRows, BASE_COLUMNS_DEFINITION, order, orderBySelector, globalFilterText, columnFilters]);
 
 const isAllSelected = processedData.length > 0 && selectedRows.length === processedData.length;
const isIndeterminate = selectedRows.length > 0 && !isAllSelected;

const columns = useMemo(() => {
  let baseColumns = [
    { 
      accessorKey: 'date', 
      header: 'Date Time', 
      size: 180, // Increased size slightly to accommodate the button
      selector: (row) => row.date, 
      filterType: 'date',
      Cell: ({ row: { original: rowData } }) => {
        const isViewDetailClickable = !!rowData.id; 
        
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{rowData.date}</span>
            <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents triggering row selection logic
                  EditData(rowData.id, aidtype);
                }}
                sx={{
                  color: 'orange',
                  p: 0.5,
                  '&:hover': {
                    color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                <VisibilityOutlined sx={{ fontSize: '1rem' }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
    { accessorKey: 'name', header: 'Name', size: 150, selector: (row) => row.name, filterType: 'text' },
    { accessorKey: 'mobile', header: 'Mobile', size: 150, selector: (row) => row.mobile, filterType: 'text' },
    { accessorKey: 'profile', header: 'Profile', size: 150, selector: (row) => row.profile, filterType: 'select', dynamicFilterOptions: dynamicFilterOptions['profile'] },
    {
      accessorKey: 'email',
      header: 'Email',
      size: 150,
      selector: (row) => row.email,
      filterType: 'text',
    },
    {
      accessorKey: 'type',
      header: 'Upload type',
      size: 150,
      selector: (row) => row.type,
      filterType: 'select',
      dynamicFilterOptions: dynamicFilterOptions['type']
    },
    {
      accessorKey: 'ress',
      header: 'Response',
      size: 150,
      selector: (row) => row.ress,
      filterType: 'select',
      dynamicFilterOptions: dynamicFilterOptions['ress']
    }
  ];

  if (selectedStatus!="all" && selectedStatus!='inter') {
    const selectColumn = {
      accessorKey: 'select',
      size: 10,
      header: (
        <Checkbox
          color="primary"
          indeterminate={isIndeterminate}
          checked={isAllSelected}
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      Cell: ({ row: { original: row } }) => {
        return (
          <Checkbox
            color="primary"
            checked={selectedRows.includes(row.id)}
            onChange={(e) => {
              e.stopPropagation();
              handleRowSelect(row.id, e.target.checked);
            }}
          />
        );
      }
    };
    baseColumns = [selectColumn, ...baseColumns];
  }

  return baseColumns;
}, [
  dynamicFilterOptions,
  selectedRows,
  handleRowSelect,
  handleSelectAll,
  isAllSelected,
  isIndeterminate,selectedStatus,EditData,aidtype
]);
 
 const handleRequestSort = useCallback((selector) => {
          const isAsc = orderBySelector === selector && order === 'asc';
          setOrder(isAsc ? 'desc' : 'asc');
          setOrderBySelector(() => selector);
 }, [order, orderBySelector]);

// form submit in category
const FormSubmit = async (e) =>{
          e.preventDefault();
          // try and catch method
            try {
              const formData = new FormData($("#mainForm")[0]);
              if($("#hidden").val()==""){
                if($("#resume").val().length==0){
                   Swal.fire({
                       position:'top-center',
                       icon:'question',
                       title:"Please select the resume"
                   });
                   return false;
                }
              }

              
             $("#showLoader").removeClass('d-none').addClass('d-flex');
               const response = await axios.post(apiurl + "registeration.php", formData);
              if (response.data.status==true) {
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                                      Swal.fire({
                                        position: "top-center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    }).then(()=>{
                                      $(".btn-close").click();
                                      fetchData(currentPage);
                                    });
              }
              else{
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                Swal.fire({
                  position: "top-center",
                  icon: "error",
                  title: response.data.message,
                  showConfirmButton: false,
                  timer: 2000
                  });
              }
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
            finally {
                $("#loader").css("display", "none");
            }
};

const sentToDST = async (e) => {
    e.preventDefault();
    
    $("#showLoader").removeClass('d-none').addClass('d-flex');
     
    try {
      const formData = new FormData($("#submitform")[0]);
      formData.append("dstteam",dstteam);
      formData.append("aidtype",aidtype);
      
      formData.append("assignID",aid);
      const response = await axios.post(apiurl + "dst_candidate.php", formData);
     
      if (response.data.status === true) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $(".modal .btn-close").click();
          fetchData(currentPage);
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
      
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
};

function checks(dd){
  if(dd=='1'){
       $("#mainForm input, #mainForm select").attr("required",true);
        $("#mainForm input[type=file]").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",false);
         $("#mainForm .btn-primary, #resumelabel").show();
  }
  else{
        $("#mainForm input, #mainForm select").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",true);
         $("#mainForm .btn-primary, #resumelabel").hide();
  }
}

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setFileUrl(url);
    setFileType(file.type);
  };

if (newloading) {
    
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

const collectAllSubmissionData = () => {
    // Check if candidates and extraCandidateData are available
    if (!candidates || !extraCandidateData) {
        console.error("Data arrays are missing for submission.");
        return [];
    }

    const submissionArray = candidates.map(candidate => {
        const candidateId = candidate.candidateid;
        const customData = extraCandidateData[candidateId] || {};
         return {
            ...candidate,      // Original data (name, campid, etc.)
            ...customData,     // New/updated data (age, qualification, responseCategory, dstRemark)
        };
    });

    return submissionArray;
};

const IvrFORM = async (e) =>{
       e.preventDefault();
       $("#showLoader").removeClass('d-none').addClass('d-flex');

      const finalData = collectAllSubmissionData();
     
    try {
      const formData = new FormData($("#submitform2")[0]);
      formData.append("aid",aid);
      formData.append("aidtype",aidtype);
      formData.append("ivrdone", JSON.stringify(finalData));
      const response = await axios.post(apiurl + "dst_candidate.php", formData);
      if (response.data.status === true) {
      
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $(".offcanvas .btn-close").click();
          fetchData(currentPage);
          setSelectedRows([]);
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
};

const updateDetails = async (idd,val) => { 
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       
       try{
        const uniqueCandidates = [...new Set(selectedRows)];
        const formdate = new FormData();
        formdate.append("com",idd);
        formdate.append("value",val);
        formdate.append("aidtype",aidtype);
        formdate.append("candidates",uniqueCandidates.join(","));
        const response = await axios.post(apiurl + 'dst_candidate.php',formdate);
        
        if(response.data.status === true) {
            $("#tera_modal3").click();
            setIvr(idd);
            setIvrData(response.data.main[0]);
            
            const newCandidates = response.data.candidates;
            setCandidates(newCandidates);
            setCandidatesId(newCandidates.map(c => c.candidateid));
            const initialExtraData = transformCandidatesToExtraData(newCandidates);
            setExtraCandidateData(initialExtraData);

         }
         else{
                  Swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Something Went Wrong !",
                    showConfirmButton: false,
                    timer: 2000
                  });
         }
       }
       catch (error) {
        console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
       }
       finally {
         $("#showLoader").removeClass('d-flex').addClass('d-none');
       }
};

const FinalForm = async () =>{
    if (isSubmitting) return;
    $("#showLoader").removeClass('d-none').addClass('d-flex');
     
    try {
       setIsSubmitting(true);
      const formData = new FormData($("#finalForm")[0]);
      if(sendType=="ivr"){
       formData.append("voice", selectvoice);
       formData.append("lang", selectLang);
      }
      else{
        formData.append("dstteam",dstteam);
      }
      formData.append("sendType",sendType);
      formData.append("aid",aid);
      formData.append('campid',NewFORM.campid);
      formData.append("newjob",jobDescription);
      formData.append("ivrrid",NewFORM.hidden);
      formData.append("ivrType",aidtype);
      formData.append("ctablehidden",NewFORM.ctablehidden);
      const response = await axios.post(apiurl + "dst_candidate.php", formData);
     
      if (response.data.status === true) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          setCurrentStep(1);
          $(".offcanvas .btn-close").click();
          fetchData(currentPage);
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
      
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
       setIsSubmitting(false);
    }
};

const allCount = allCandidates.length;
const pendingCount = pending.length;
const interCount = inter.length;
const nointerCount = notinter.length;
const otherCount = other.length;

const filteredCandidates = candidates.filter(item => {
  const search = debouncedFilter.toLowerCase();

  return (
    (item.name && item.name.toLowerCase().includes(search)) ||
    (item.mobile && item.mobile.toString().includes(search))
  );
});

return(
<>

   {isMenuOpen && (
    <Menu
        anchorEl={popoverRef.current}
        open={isMenuOpen}
        onClose={handleClosePopover}
        disableEnforceFocus // Stops the "Maximum call stack" error
        disableRestoreFocus // Prevents focus jumping back and triggering Bootstrap
        PaperProps={{ 
            sx: { p: 2, minWidth: 200, maxWidth: 300 } 
        }}
    >
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
            IVR Remark
        </Typography>
        <Typography variant="body2">
            {activeRemark || "No remark available"}
        </Typography>
    </Menu>
)}

<button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal2" type="button" style={{ display: 'none' }}></button>
<button data-bs-toggle="modal" id="tera_modal33" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>

<div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
    <div className="modal-dialog modal-xl">
        <div className="modal-content">
            <div className="modal-header bg-light py-2">
                <h5 className="modal-title"><strong>Candidate Detail</strong></h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '85vh', overflowY: 'auto' }}>
                
                {/* 1. SECTION: CANDIDATE BASIC DETAILS */}
                <h6 className="text-primary mb-2"><strong>Personal Information</strong></h6>
                <table className="table table-bordered" style={{ tableLayout: "fixed", fontSize: '0.85rem' }}>
                    <tbody>
                        <tr>
                            <th style={{ backgroundColor: "#f0f7ff", width: '15%' }}>Name</th>
                            <td style={{ width: '35%' }}>{requirement.candidate_name || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff", width: '15%' }}>Mobile</th>
                            <td style={{ width: '35%' }}>{requirement.mobile || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff", width: '15%' }}>Email</th>
                            <td style={{ width: '35%' }}>{requirement.email || "-"}</td>
                        </tr>
                        <tr>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Age</th>
                            <td>{requirement.age || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Client</th>
                            <td colSpan="3">{requirement.clientName || "-"}</td>
                        </tr>
                        <tr>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Candidate Location</th>
                            <td>{requirement.location || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Pincode</th>
                            <td>{requirement.pincode || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Profile</th>
                            <td>{requirement.profile || "-"}</td>
                        </tr>
                        <tr>
                            
                            <th style={{ backgroundColor: "#f0f7ff" }}>Qualification</th>
                            <td>{requirement.qualification || "-"}</td>
                            
                            <th style={{ backgroundColor: "#f0f7ff" }}>Experience</th>
                            <td>{requirement.exp || "-"}</td>
                            <th style={{ backgroundColor: "#f0f7ff" }}>Added Time</th>
                            <td>{requirement.datestimes || "-"}</td>
                        </tr>
                        <tr>
                             <th style={{ backgroundColor: "#f0f7ff" }}>Response</th>
                            <td>{requirement.response || "-"}</td>
                        
                          <th style={{ backgroundColor: "#f0f7ff" }}>DST Remark</th>
                          <td colSpan>{requirement.dremark || "-"}</td>
                          </tr>
                    </tbody>
                </table>
            </div>
            <div className='modal-footer py-1'>
                <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

 {metaData.edit===1 && (
<div className="modal effect-flip-vertical fade" id="DstModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
    <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
            <div className="modal-header bg-light py-2">
                <h5 className="modal-title"><strong>Assign to DST</strong></h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ minHeight: '260px', padding: '1.5rem 1.5rem 1.25rem', overflowY: 'auto' }}>
            <form id="submitform" onSubmit={sentToDST} encType="multipart/form-data" className='order-2'>
            <div className='row g-3'>
              <div className='col-12'>
                <label className="form-label">Select DST TEAM</label>
                     <Select
                                          options={team}   // must be an array
                                          isMulti
                                          closeMenuOnSelect={false}
                                          value={team.filter(opt => dstteam.includes(opt.value))}
                                          onChange={(options) => setSelectTeam(options.map(opt => opt.value))}
                                          placeholder="Select DST"
                                        />
              </div>
              <div className='col-12'>
                <button type='submit' className='btn btn-primary px-4'>Submit</button>
              </div>
            </div>
            </form>
            </div>
        </div>
      </div>
  </div>
 )}
{metaData.add===1 && (
<div className="offcanvas offcanvas-end" style={{width:'100%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="bulkmodal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1" style={{fontSize:'19px'}}>Add Candidate & IVR Run</h5>
        <button type="button" className="btn-close" id='modalclose2' data-bs-dismiss="offcanvas" aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   
   <div className={`form-step ${currentStep === 1 ? "active" : ""}`} data-step="1">
   
    <form id="bulkForm" encType="multipart/form-data">
    <div className="row g-3" style={{position:'relative'}}>
      
          		<div className="col-lg-3" >
                     {/* Category Input */}
                     <label htmlFor="name2" className="form-label">Spoc Name</label>
                      <input  id="name2" name="name2" className="form-control" autoComplete='off'  placeholder='Spoc Name' required defaultValue=""/>
                </div>
                <div className="col-lg-3">
                       <label htmlFor="mobile2" className="form-label">Spoc Mobile No.</label>
                      <input  id="mobile2" name="mobile2" className="form-control" autoComplete='off' placeholder='Spoc Mobile No.' maxLength={10} minLength={10} inputMode='numeric' required defaultValue=""/>
                </div>
             
                <div className="col-lg-3">
                       <label htmlFor="location2" className="form-label">Spoc Location</label>
                      <input  id="location2" name="location2" className="form-control" autoComplete='off' placeholder='Spoc Location' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
</div>
<div className='row'>
                <div className="col-3" style={{paddingTop:'20px'}}>
                     <button className="btn btn-sm btn-danger" onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=1`;}} type="button">Sample Bulk File Download</button>
                     <button className="btn btn-sm btn-info" style={{marginLeft:'20px'}} onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL}demo/download.php?tt=2`;}} type="button">CSV File Steps PDF</button>
                   <div className='row'>
                    <div className='col-12'>
                  <p className="form-label">Scan File</p>
                      <input id="bulk" style={{display:'none'}}  accept=".csv" name="bulk" className="form-control" autoComplete='off' type='file' defaultValue="" onChange={handleFileChange2}/>
                    <label htmlFor="bulk"  className='form-label' style={{float:'left',marginRight:'20px',width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <i className='ri-qr-scan-2-line' style={{fontSize:'25px'}}></i>
                      </label>
                   {fileInfo && (
                            <div style={{marginTop:'10px',float:'left'}}>
                              <div style={{ fontWeight: "500" }}>{fileInfo.name}</div>
                              <small style={{ color: "#6c757d" }}>
                                {(fileInfo.size / 1024).toFixed(2)} MB
                              </small>
                            </div>
                          )}
                </div>
                   </div>
               
                </div>

              
<div className="col-3" style={{ paddingTop: "20px" }}>
  <label className="form-label fw-bold">
    <span className="text-danger">*</span>{sendType === "ivr" ? "Sent for IVR" : "Sent to DST"}
  </label>

<div class="custom-toggle-switch d-flex align-items-center mb-4"> 
  <input id="toggleswitchSuccess" name="toggleswitch001" type="checkbox"
      checked={sendType === "ivr"}   // ON = IVR
      onChange={(e) =>
        setSendType(e.target.checked ? "ivr" : "dst")
      }/> 
  <label for="toggleswitchSuccess" class="label-success"></label><span class="ms-3">{sendType === "ivr" ? "Sent for IVR" : "Sent to DST"}</span>
 </div>

  <span dangerouslySetInnerHTML={{ __html: metaData.notes }} />
</div>
</div>
    
    </form>
   
   </div>
   <div className={`form-step ${currentStep === 2 ? "active" : ""}`} data-step="2">
        <form id="finalForm" encType="multipart/form-data">
             
              <div className="row g-3">
               <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="organName" className="form-label">Campaign Id</label>
                  <input value={NewFORM.campid || ""} type="text" className="form-control" placeholder="Campaign ID" readOnly disabled/>
                </div>
                 <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="organName" className="form-label">Requirement Id</label>
                  <input value={NewFORM.requireid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
                </div>
                
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="organName" className="form-label">Client Name</label>
                  <input value={NewFORM.client || ""} type="text" className="form-control" placeholder="Organisation name" readOnly  disabled/>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="skills" className="form-label">Location</label>
                  <input  value={NewFORM.location || ""}  type="text" className="form-control" placeholder="Location"  readOnly  disabled/>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="short" className="form-label">Job Title</label>
                  <input  defaultValue={NewFORM.jobTitle || ""} type="text" name='newTitle' className="form-control" placeholder="JOB TITLE"  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="detail" className="form-label">MIN EXP.</label>
                  <input  defaultValue={NewFORM.expFrom || ""}  type="text" name='newMinExp' className="form-control" placeholder="Min Experience"  />
                </div>
                 <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="detail" className="form-label">MAX EXP.</label>
                  <input defaultValue={NewFORM.expTo || ""}  type="text" name='newMaxExp' className="form-control" placeholder="MAX Experience"  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6">
                  <label htmlFor="name" className="form-label">Min Salary</label>
                  <input defaultValue={NewFORM.ctcFrom || ""}  type="text" name='newMinSalary' className="form-control" placeholder="MIN SALARY"  />
                </div>
                 <div className="col-lg-6">
                  <label htmlFor="name" className="form-label">Max Salary</label>
                  <input defaultValue={NewFORM.ctcTo || ""}  type="text" name='newMaxSalary' className="form-control" placeholder="MAX SALARY" />
                <div className='col-12'>
                       <label htmlFor="jobDescription" className="form-label">JOB DESCRIPTION</label>
                       <ReactQuill  value={jobDescription}  onChange={setJobDescription} theme="snow" modules={{ toolbar: false }} style={{maxHeight:'300px', minHeight:'50px',border: "1px solid darkgrey", borderRadius: '10px' }}/>
                </div>
                </div>

<style jsx>{`
  .ql-container {
    height: auto !important;
    min-height: 50px; 
  }
  .ql-editor {
    min-height: 50px;
    max-height: 300px; 
    overflow-y: auto;
  }
`}</style>
 
              <div className='col-lg-6'>
                 {sendType=="ivr" ? (
                <div className="row g-3">
  
                <div className="col-6">
                  <label htmlFor="organName" className="form-label"><span className='text-danger fs-15'>*</span>Organisation name</label>
                  <input defaultValue={NewFORM.organName || ""} id="organName" name="organName" type="text" className="form-control" placeholder="Organisation name" required />
                </div>
                <div className="col-6">
                  <label htmlFor="skills" className="form-label">SKILLS</label>
                  <input defaultValue={NewFORM.skills || ""} id="skills" name="skills" type="text" className="form-control" placeholder="Skills" />
                </div>
                <div className="col-6">
                  <label htmlFor="short" className="form-label">Organisation Short Description</label>
                  <input defaultValue={NewFORM.short || ""} id="short" name="short" type="text" className="form-control" placeholder="Short Description" />
                </div>
                <div className="col-6">
                  <label htmlFor="detail" className="form-label">Organisation Detailed Description</label>
                  <input defaultValue={NewFORM.detail || ""} id="detail" name="detail" type="text" className="form-control" placeholder="Detail Description" />
                </div>
                <div className="col-6">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input defaultValue={NewFORM.name || ""} id="name" name="names" type="text" className="form-control" placeholder="Name" />
                </div>
                <div className="col-6">
                  <label htmlFor="caller" className="form-label"><span className='text-danger fs-15'>*</span>Caller name</label>
                  <input defaultValue={NewFORM.caller || ""} id="caller" name="caller" type="text" className="form-control" placeholder="Caller Name"  required/>
                </div>
                <div className="col-6">
                  <label htmlFor="mobile" className="form-label"><span className='text-danger fs-15'>*</span>CALLER MOBILE NUMBER</label>
                  <input defaultValue={NewFORM.mobile || ""} id="mobile" name="mobile" type="text" className="form-control" placeholder="Mobile Number" required />
                </div>

                               <div className="col-6">
                                  <label htmlFor="lanugage" className="form-label"><span className='text-danger fs-15'>*</span>Language Id</label>
                                  <Select
                                    options={lanugage || []}
                                    value={(lanugage || []).find(opt => opt.value === selectLang) || null}
                                    onChange={(option) => { const lang = option ? option.value : null; setLanguage(lang); setVoice(voiceDefaultMap[lang] || null); }}
                                    placeholder="Select Language" onMenuOpen={() => {}}
                                  />
                                </div>
                      <div className="col-6">
                                      <label htmlFor="voice" className="form-label"><span className='text-danger fs-15'>*</span>CAMPAGIN VOICE ID</label>
                                      <Select
                                        options={voice || []}
                                        value={(voice || []).find(opt => opt.value === selectvoice) || null}
                                        onChange={(option) => setVoice(option ? option.value : null)}
                                        placeholder="Select Voice Id" onMenuOpen={() => {}}
                                      />
                     </div>
          
              
              </div>
               ):(
              <>
                <label htmlFor="clientName" className="form-label"><span className='text-danger fs-15'>*</span>DST TEAM</label>
                <Select
                options={team}   // must be an array
                isMulti
                closeMenuOnSelect={false}
                value={team.filter(opt => dstteam.includes(opt.value))}
                onChange={(options) => setSelectTeam(options.map(opt => opt.value))}
                placeholder="Select DST TEAM"
                />
              </>
              )}
              </div>
              </div>
             
        </form>
   </div> 
   <div className="wizard-footer">
    {currentStep < totalSteps && (
        <button type="button" onClick={handleNext} className="btn next-btn" disabled={isSubmitting}>
            Add Candidates
        </button>
    )}
    {currentStep === totalSteps && (
        <button type="button" onClick={FinalForm} id="initiateBtn" className="btn next-btn" disabled={isSubmitting}>
            {isSubmitting
      ? "Processing..."
      : `Sent to ${sendType.toUpperCase()}`}
        </button>
    )}
</div>
 
</div>

</div>
)}

 <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal2" >
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1">Update Details</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
         
            <form id="submitform2" onSubmit={IvrFORM} encType="multipart/form-data" className='order-2'>
             <div className="row g-3">
            
            <div className='col-6'>
               <div className='row'>
                     <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="organName" className="form-label">Campaign Id</label>
                  <input value={ivrdata.campid || ""} type="text" className="form-control" placeholder="Campaign ID" readOnly disabled/>
                </div>
             
                 <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="organName" className="form-label">Requirement Id</label>
                  <input value={ivrdata.requireid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
                </div>
                
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="organName" className="form-label">Client Name</label>
                  <input value={ivrdata.client || ""} type="text" className="form-control" placeholder="Organisation name" readOnly  disabled/>
                </div>
                 <div className="col-xl-12 col-lg-12 col-md-12">
                  <label htmlFor="client" className="form-label">Job Description</label>
                 <div dangerouslySetInnerHTML={{ __html: ivrdata.jobDescription }}  className="form-control" style={{ minHeight: '100px', padding: '0.375rem 0.75rem', overflowY: 'auto' }}>
</div>
                </div>
                
               </div>
            </div>
                
           </div>

            <div className='col-12'  style={{padding:'0px',textAlign:'right'}}>
      <input
        type="text"
        placeholder="Search candidates By Mobile & Name"
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
        style={{ padding: '8px', width: '300px', borderRadius: '4px', border: '1px solid #ccc' }}
      />
    
              <button type="submit" className="btn btn-primary">Sent to Recruiter</button>
            </div>
            
            </form>

        <div className='row'>
         <div className='col-12' style={{ width: '100%', overflowX: 'auto' }}>
        <div style={{ minWidth: '1200px' }}>
           <DataTable columns={allColumns} data={filteredCandidates} pagination striped/>
        </div>

          </div>
        </div>
        </div>

 </div>

<div className="offcanvas offcanvas-top" style={{maxHeight:'100%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="exampleModal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1">Add Candidate</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose"  aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   
   <div className='d-flex'>

  <form id="mainForm" onSubmit={FormSubmit} encType="multipart/form-data" className='order-2'>
<div className="row g-3" style={{position:'relative'}}>
          		<div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="name" className="form-label">Name</label>
                      <input  id="name" name="name" className="form-control" autoComplete='off'  placeholder='Candidate Name' required />
                </div>
                <div className="col-lg-6">
                       <label htmlFor="mobile" className="form-label">Mobile No.</label>
                      <input  id="mobile" name="mobile" className="form-control" autoComplete='off' placeholder='Mobile No.' maxLength={10} minLength={10} inputMode='numeric' required defaultValue=""/>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="email" className="form-label">Email</label>
                      <input  id="email" name="email"  type="email" className="form-control" autoComplete='off' placeholder='Email adddress' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="profile" className="form-label">Profile</label>
                      <input  id="profile" name="profile" className="form-control" autoComplete='off' placeholder='Enter Your Profile' required defaultValue=""/>
                </div>

                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="age" className="form-label">Date of Birth</label>
                      <input type='date' id="age" name="age" className="form-control" autoComplete='off' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="qual" className="form-label">Qualification</label>
                      <select  id="qual" name="qual" className="form-control" required defaultValue="">
                         <option value="" hidden>Select Qualification</option>
                          <option value="Below 10th">Below 10th</option>
<option value="10th Pass">10th Pass</option>
<option value="12th Pass">12th Pass</option>
<option value="Diploma">Diploma</option>
<option value="Graduate">Graduate</option>
<option value="Post Graduate">Post Graduate</option>
<option value="Doctorate">Doctorate (PhD)</option>
<option value="Professional Certification">Professional Certification</option>
<option value="Other">Other</option>
                      </select>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="exp" className="form-label">Experience</label>
                      <select  id="exp" name="exp" className="form-control" required defaultValue="">
                        <option value="" hidden>Enter Experience</option>
                    <option value="Fresher">Fresher</option>
<option value="<1 year">&lt;1 year</option>
<option value="1-2 years">1–2 years</option>
<option value="2-3 years">2–3 years</option>
<option value="3-4 years">3–4 years</option>
<option value="4-5 years">4–5 years</option>
<option value="5-7 years">5–7 years</option>
<option value="7-10 years">7–10 years</option>
<option value="10+ years">10+ years</option>
<option value="15+ years">15+ years</option>
                     </select>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="pincode" className="form-label">Pincode</label>
                      <input  id="pincode" name="pincode" className="form-control" autoComplete='off' minLength={6} maxLength={6} placeholder='Enter Your Pincode' required defaultValue=""/>
                </div>

                <div className="col-lg-6">
                       <label htmlFor="city" className="form-label">City/District</label>
                      <input  id="city" name="city" className="form-control" autoComplete='off' placeholder='Enter City' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="state" className="form-label">State</label>
                      <input  id="state" name="state" className="form-control" autoComplete='off'  placeholder='Enter your State' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-2" id='resumelabel'>
                     {/* Category Input */}
                     <p className="form-label">Upload Resume</p>
                      <input id="resume" accept="image/*,.pdf" onChange={handleFileChange} name="resume" className="form-control" autoComplete='off' type='file' defaultValue="" style={{display:'none'}}/>
                      <label htmlFor="resume"  className='form-label' style={{width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <span style={{fontSize:'35px',marginTop:'-9px',display:'inline-block'}}>+</span>
                      </label>
                </div>
                <div className='col-lg-4' id='fileTxt'>
        {fileUrl && fileType?.startsWith('image/') && (
          <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%' ,height:'150px'}} />
        )}

        {fileUrl && fileType == 'application/pdf' && (
          <iframe src={fileUrl} title="PDF Preview" style={{width:'100%',height:'150px'}}></iframe>
        )}

        {fileUrl && !fileType.startsWith('image/') && fileType != 'application/pdf' && (
          <p>File preview not supported for this file type.</p>
        )}
      </div>
        
             <div className='col-12'  style={{padding:'0px',textAlign:'right'}}>
              <input type="hidden" name="hidden" id="hidden" />
              <input type='hidden' name='aid' id='aid' value={aid}/>
              <input type="hidden" name="token" value={sessionStorage.getItem('token')}/>
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Submit</button>
            </div>
    </div>
      </form>

      <img className="order-1" src={process.env.PUBLIC_URL + "/admin_assets/images/media/media-88.svg"} style={{width:'100%',height:'100%'}}/> 

   </div>
   
 
</div>

</div>



<div className="main-content app-content">
                 
 <div className="container-fluid">
 
   <div className="row">

<div class="col-xl-12 mt-4">
    <div class="card custom-card">
        <div class="card-header" style={{display:'flex',justifyContent:'space-between'}}><div class="card-title">Campaign Details </div>
        
        {(metaData.add===1) && (
         <div> 
         <button className="btn btn-primary ms-2" data-bs-toggle="offcanvas" id="bulkupload" data-bs-target="#bulkmodal">Bulk Upload</button>
        </div>
         )}

        {metaData.edit===1 && (
            <div>
             <button className="btn btn-primary ms-2" data-bs-toggle="modal"data-bs-target="#DstModal">Add DST Team</button>
            </div>
          )}
          <Tooltip title="Download Candidates Data" arrow>
          <IconButton
            size="medium"
            onClick={() => {
              window.location = `${apiurl}dst_candidate.php?subdomain=react&export=xls&aid=${aid}&aidtype=${aidtype}`;
            }}
            sx={{
              color: '#fff',
              background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
              borderRadius: '10px',
              p: 1,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.35)',
              transition: 'all 0.25s ease',
              '&:hover': {
                background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
                transform: 'translateY(-1px)',
                boxShadow: '0 6px 16px rgba(13, 71, 161, 0.45)',
              },
              '&:active': {
                transform: 'scale(0.95)',
              },
            }}
          >
            <DownloadOutlined sx={{ fontSize: '1.4rem' }} />
          </IconButton>
        </Tooltip>
          <button className="btn btn-primary ms-2" onClick={()=> navigate(-1)}>Back</button>
        </div>
        <div class="card-body">
            <div class="row gy-md-0 gy-3" style={{gap:'15px 60px'}}>
 
 {stats.map((item, index) => (
 
 <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                    <div class="d-flex align-items-top">
                        <div>
                            <span class="d-block mb-1 text-muted">{item.label}</span>
                            <h6 class="fw-semibold mb-0">{item.count}</h6>
                        </div>
                    </div>
                </div>

  ))}
 </div>
 
        </div>
    </div>
</div>

</div>

<div className="row">
   
<div className="col-xxl-12 col-xl-12 ">
   
<div className="card custom-card">
  
<div className="card-header justify-content-between" style={{paddingBottom:'10px',alignItems:'normal'}}>
 
<div className="d-flex align-items-center gap-3 mb-0">
  {/* All Button */}
  <button
    className={getButtonClass('all')}
    onClick={() => setSelectedStatus('all')}
    style={{ minWidth: '120px' }}
  >
    <span>All</span>
    <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
      {allCount}
    </span>
  </button>
  {/* Interested Button */}
  <button
    className={getButtonClass('inter')}
    onClick={() => setSelectedStatus('inter')}
    style={{ minWidth: '130px' }}
  >
    <span>Interested</span>
    <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
      {interCount}
    </span>
  </button>

  {/* Pending Button */}
  <button
    className={getButtonClass('pending')}
    onClick={() => setSelectedStatus('pending')}
    style={{ minWidth: '120px' }}
  >
    <span>Pending</span>
    <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
      {pendingCount}
    </span>
  </button>

  

  {/* Not Interested Button */}
  <button
    className={getButtonClass('nointer')}
    onClick={() => setSelectedStatus('nointer')}
    style={{ minWidth: '130px' }}
  >
    <span>Not Interested</span>
    <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
      {nointerCount}
    </span>
  </button>

  {/* Other Button */}
  <button
    className={getButtonClass('other')}
    onClick={() => setSelectedStatus('other')}
    style={{ minWidth: '120px' }}
  >
    <span>RNR</span>
    <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
      {otherCount}
    </span>
  </button>
</div>

     <div className="d-flex mt-sm-0 mt-2 align-items-center">
      
      <button
  className="btn btn-primary"
  type="button"
  onClick={() => updateDetails(aid, aidtype)}
  disabled={selectedRows.length === 0}
  style={{ marginRight: '20px' }}
>
  UPDATE DETAILS
</button>


        <div className="input-group" style={{width:'auto'}}>
            <input type="text" className="form-control bg-light border-0" placeholder="Search Candidate" aria-describedby="search-contact-member" />
            <button className="btn btn-light" style={{zIndex:'0'}} type="button" id="search-contact-member"><i className="ri-search-line text-muted"></i></button>
        </div>
        

    </div>
  
</div>

<div className="card-body" style={{ padding: '0px' }}>

           <TableContainer sx={{ maxHeight: '700px'}}>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>


 <TableBody>
    {processedData.map((row, index) => {

const isSelectable = selectedStatus !== "all" && selectedStatus !== "inter";
const isSelected = selectedRows.includes(row.id);
const clickHandler = isSelectable ? () => handleRowSelect(row.id, !isSelected) : undefined;
const rowBackgroundColor = isSelectable && isSelected ? "#d0ebff" : 'inherit';
const rowHoverColor = isSelectable ? (isSelected ? "#a3d3ff" : '#f5f5f5'): 'inherit'; // If not selectable, hover is just 'inherit
       
return(
        <TableRow 
        key={index} 
        onClick={clickHandler} 
        sx={{ 
            cursor: isSelectable ? 'pointer' : 'default', 
            backgroundColor: rowBackgroundColor,
            '&:hover': {
                backgroundColor: rowHoverColor, 
            }
        }}
    >
            {columns.map((column) => {
                let cellContent;
                const cellWidth = column.size ? column.size : 150;
                 
                if (column.Cell) {
                    cellContent = column.Cell({ row: { original: row } });
                }
                // 2. Handle specific accessorKeys with custom logic (like 'rid')
                else {
                        const value = column.selector ? column.selector(row) : null;
                        cellContent = value;
                
              }
                return (
                    <TableCell 
                        key={column.accessorKey}
                        sx={{ p: 1.5, fontSize: '0.875rem',minWidth:cellWidth,width:cellWidth}}>
                        {cellContent}
                    </TableCell>
                );
            })}
        </TableRow>
        );
})}
    
    {/* Empty state if no data */}
    {processedData.length === 0 && (
        <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                <Typography color="textSecondary" variant="body1">
                    No matching found in the current filters.
                </Typography>
            </TableCell>
        </TableRow>
    )}
</TableBody>
               
            </Table>
            </TableContainer>

</div>

</div>
        
</div></div>

</div></div>

</>
);
}
export default ReRgister;
